import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
    var header = $('.nav-primary');
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 154) {
        header.addClass('nav-fixed');
      } else {
        header.removeClass('nav-fixed');
      }
    });

    $('.hp-hero').slick({
      dots: true,
      infinite: true,
      arrows: false,
      speed: 1500,
      fade: true,
      autoplay: true,
      cssEase: 'linear',
    });

    $('.slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 2500,
      fade: true,
      autoplay: true,
    });

    $('.logo-carousel').slick({
      infinite: true,
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      $.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');
        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
        }
        // Replace image with new SVG
        $img.replaceWith($svg);
      }, 'xml');

    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js